import ProdutoModel from "./ProdutoModel";
import C5CarrinhoItemModel from "./C5CarrinhoItemModel";
import AppState from "./AppState";
import LojaModel from "./LojaModel";

export default class CarrinhoItemModel {
  public carrinhoItemId: string = "";
  public produto: ProdutoModel = new ProdutoModel();
  public quantidade: number = 0;
  public notas: string = "";
  public adicionado: Date = new Date();

  public static toC5CarrinhoItemModel(item: CarrinhoItemModel): C5CarrinhoItemModel {
    const loja: LojaModel | null = AppState.getLojaSelecionada();

    let model: C5CarrinhoItemModel = {
      Category: item.produto.categoria,
      ItemNote: item.notas,
      ItemQuantity: item.quantidade,
      ProductID: item.produto.produtoId,
      SaleUnit: item.produto.unidade,
      StoreID: "",
      UIDBasket: AppState.getCarrinho().carrinhoId
    } as C5CarrinhoItemModel;

    if (loja) {
      model.StoreID = loja.lojaId;
    }

    if (item.produto.unidade === "GR") {
      model.ItemQuantity = item.quantidade * item.produto.fatorMultiplicacao;
    }

    return model;
  }
}